import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./theme/ThemeProvider";
import ErrorBoundary from "./components/ErrorBoundary";
import OrgAdminProtectedRoute from "./components/OrgAdminProtectedRoute";
import PageSuspenseFallback from "./components/PageSuspenseFallback";

const OrgAdminLayout = React.lazy(() => import("./components/layout/OrgAdminLayout"));
const OTPLogin = React.lazy(() => import("./pages/OTPLogin"));
const ForceResetPassword = React.lazy(() => import("./pages/ForceResetPassword"));
const ChangePassword = React.lazy(() => import("./pages/ChangePassword"));
const ClientManagementPage = React.lazy(() => import("./pages/ClientManagementPage"));
const MonitoringDashboard = React.lazy(() => import("./pages/MonitoringDashboard"));
const RenewalsCollectionsPage = React.lazy(() => import("./pages/RenewalsCollectionsPage"));
const NewCustomerPage = React.lazy(() => import("./pages/customers/NewCustomerPage"));
const CustomerWorkspacePage = React.lazy(() => import("./pages/customers/CustomerWorkspacePage"));
const TicketsPage = React.lazy(() => import("./pages/customers/Tickets").then((m) => ({ default: m.TicketsPage })));

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
          <React.Suspense fallback={<PageSuspenseFallback fullPage />}>
            <Routes>
            {/* Public routes */}
            <Route path="/login" element={<OTPLogin />} />
            <Route path="/force-reset-password" element={<ForceResetPassword />} />
            <Route path="/change-password" element={<ChangePassword />} />

            {/* Protected admin routes */}
            <Route element={<OrgAdminProtectedRoute />}>
              <Route element={<OrgAdminLayout />}>
                <Route path="/" element={<ClientManagementPage />} />
                <Route path="/clients" element={<ClientManagementPage />} />
                <Route path="/clients/new" element={<NewCustomerPage />} />
                <Route path="/clients/:clientId" element={<CustomerWorkspacePage />} />
                <Route path="/clients/:clientId/:section" element={<CustomerWorkspacePage />} />
                <Route path="/tickets" element={<TicketsPage />} />
                <Route path="/tickets/:ticketNumber" element={<TicketsPage />} />
                <Route path="/monitoring" element={<MonitoringDashboard />} />
                <Route path="/renewals" element={<RenewalsCollectionsPage />} />
              </Route>
            </Route>

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </React.Suspense>
        </AuthProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
